import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

/**
 * Translates the router status to the case sidebar open/closed status
 *
 * Should mainly be used through the useCaseSidebarNavigator hook, but
 * can be used directly in cases where the other hook hasn't been provided yet.
 */
export const useCaseSidebarRoutingToggle = () => {
  const route = useRoute()
  const router = useRouter()

  const isSidebarOpen = computed(() => route.name === 'CaseDetails')

  const closeSidebar = () => router.push({ name: 'Case', params: route.params, query: route.query })

  const openSidebar = () =>
    router.push({ name: 'CaseDetails', params: route.params, query: route.query })

  return { isSidebarOpen, closeSidebar, openSidebar }
}
